<ul>
  @for (link of links; track link) {
    <li>
      <a [routerLink]="link.url" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact: false}">
        {{link.name}}
      </a>
    </li>
  }
</ul>
